import React from "react";

import PageHeader from "../../../molecules/PatientDetailsV2/PageHeader/PageHeader";
import ScoreProgress from "../../../molecules/Progress/ScoreProgress/ScoreProgress";
import ProgressTabs from "../../../molecules/Progress/ProgressTabs/ProgressTabs";
import { useLocation } from "react-router-dom";

const tabs = ["Exercise", "Diet", "Success", "Diagnostics"];

const MainGoalsPage = () => {
  return (
    <div>
      <PageHeader title="Main Goals" />
      <ScoreProgress />
      {/* <AssessmentGoal tabs={tabs} /> */}
      <ProgressTabs tabs={tabs} isPrimary={true} />
    </div>
  );
};

export default MainGoalsPage;
